import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  FormSelect,
} from "@themesberg/react-bootstrap";
import Select from "react-select";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import swal from "sweetalert";
import axios from "axios";
import {
  createTimeOff,
  getTimeOff,
  updateTimeOff,
  getVendorList,
} from "../../app/api";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Loadericon from "../../components/Loadericon";
export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [details, setSDetails] = useState("");
  const [vendor, setVendor] = useState([]);
  const [vendorId, setVendorID] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const token = localStorage.getItem("token");
      const formattedFromDate = moment(fromdate).format("YYYY-MM-DD HH:mm:ss");
      const formattedToDate = moment(todate).format("YYYY-MM-DD HH:mm:ss");
      const timeoff = {
        time_off_from: formattedToDate,
        time_off_to: formattedFromDate,
        vendor_id: vendorId,
        status,
        notes,
        details,
      };
      let response;
      if (id) {
        response = await axios.put(updateTimeOff(id), timeoff, {
          headers: {
            "Content-Type": "application/json", // Set Content-Type to application/json
            "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
            "auth-token": `Bearer ${token}`,
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.Timeoff.path);
        });
      } else {
        response = await axios.post(createTimeOff(), timeoff, {
          headers: {
            "Content-Type": "application/json", // Set Content-Type to application/json
            "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
            "auth-token": `Bearer ${token}`,
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        });
       
          setFromdate("");
          setTodate("");
          setStatus("");
          setNotes("");
          setSDetails("");
          setVendorID("");
        
      }

      // console.log(response.data);
    } catch (error) {
      // console.error(error);
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      
    }
  };
  const fetchSingleTimeoff = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getTimeOff(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setFromdate(response.data?.data?.time_off_from);
      setTodate(response.data?.data?.time_off_to);
      setStatus(response.data?.data?.status);
      setNotes(response.data?.data?.notes);
      setSDetails(response.data?.data?.details);
      setVendorID(response.data?.data?.vendor_id);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchvendorsList = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(getVendorList(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        // console.log("vendor dropdown", response.data?.data);
        setVendor(response.data?.data);
      } catch (error) {
        // console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchvendorsList();
  }, []);
  useEffect(() => {
    fetchSingleTimeoff();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Timeoff.path);
  };
  const vendorList = vendor.map((v) => ({
    value: v.id,
    label: v.company_name,
  }));
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Back</Breadcrumb.Item>
            <Breadcrumb.Item active>{id?"Update Time Off":"Create Time Off"}</Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Time Off</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {id ? "Update Time Off" : "Create a New Time Off"}
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      {/* <Col md={6} className="mb-3">
                        <Form.Group id="Vendor Name">
                          <Form.Label>Vendor Name</Form.Label>
                          <Form.Select
                            value={vendorId}
                            onChange={(e) => setVendorID(e.target.value)}
                          >
                            <option value="0">Select Vendor</option>
                            {vendor.map((v) => (
                              <option key={v.id} value={v.id}>
                                {v.company_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col> */}
                      <Col md={6} className="mb-3">
                      <Form.Group id="Vendor Name">
                      <Form.Label>Vendor Name</Form.Label>
                      <Select
                     
                  options={vendorList}
                  placeholder="Select Vendor"
                  value={
                    vendorList.find((option) => option.value === vendorId) ||
                    null
                  }
                 
                  onChange={(selectedOption) => {
                    setVendorID(selectedOption.value);
                  }}
                  styles={{
                    container: (base) => ({
                      ...base,
                      borderRadius: "5px",
                      width: "100%",
                    }),
                  }}
                />
                </Form.Group>
                </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="status">
                          <Form.Label>Status</Form.Label>
                          <Form.Select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option value="0">Select Status</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approve</option>
                            <option value="rejected">Rejected</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="From Date">
                          <Form.Label>From Date</Form.Label>
                          <Datetime
                            timeFormat={false}
                            onChange={(e) => setFromdate(e)}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    fromdate
                                      ? moment(fromdate).format("MM/DD/YYYY")
                                      : ""
                                  }
                                  placeholder="mm/dd/yyyy"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="To Date">
                          <Form.Label>To Date</Form.Label>
                          <Datetime
                            timeFormat={false}
                            onChange={(e) => setTodate(e)}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    todate
                                      ? moment(todate).format("MM/DD/YYYY")
                                      : ""
                                  }
                                  placeholder="mm/dd/yyyy"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Notes">
                          <Form.Label>Notes</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Notes"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Detail">
                          <Form.Label>Detail</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Detail"
                            value={details}
                            onChange={(e) => setSDetails(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>
                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          type="submit"
                          variant="primary"
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}{" "}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
